import React , {useEffect, useState } from "react";
import { GetProfileImages } from "../../DocumentDetails/slice";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { messages } from "../../../data";
import CheckIcon from "@mui/icons-material/Check";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import {
  query,
  orderBy,
  limit,
  onSnapshot,
  collection as firebaseCollection,
  collectionGroup,
  where,
  getDocs,
} from "firebase/firestore";

import { DEFAULT_AVATAR_URL } from "../../../common/enum";
import { db } from "../../../firebase";
import { ListItemButton } from "@mui/material";
import ChatPanel from "../../MessagePanel/ChatPanel";
import { fetchAllNotifications } from "../slice";
import { useDispatch, useSelector } from "react-redux";
export default function MessageList({ t }) {
  const {
    auth: { profile },
  } = useSelector((state) => state);
  const [entitiesMessage, setEntitesMessage] = React.useState([]);
  const [entitiesNotifications, setEntitiesNotifications] = React.useState([]);
  const [selectedIndex, setSelectedIndex] = React.useState();
  const [chatdrawerState, setChatDrawerState] = React.useState(false);
  const [chatId, setChatId] = React.useState();
  const [particularDonation, setParticularDonation] = React.useState();
  const [entityDonation, setEntityDonation] = React.useState();
  const dispatch = useDispatch();
  const toggleChatDrawer = React.useCallback((value) => {
    setChatDrawerState(value);
  }, []);

  const getEntityDonation = React.useCallback(async (message) => {
    const qu = query(
      firebaseCollection(
        db,
        "entityChats" + "/" + `${profile?.userId}` + "/" + "entityInfo"
      ),
      where("entityId", "==", message.senderId)
    );
    const res = await getDocs(qu);
    setEntityDonation(res.docs[0].data());
    setParticularDonation(message);
    setChatDrawerState(true);
  }, []);

  const handleListItemClick = React.useCallback(
    (event, index, message, chatUid) => {
      getEntityDonation(message);
      setSelectedIndex(index);
      setChatId(chatUid);
    },
    []
  );

  React.useEffect(() => {
    const getData = () => {
      const qu = query(
        collectionGroup(db, "messages"),
        where("recevierId", "==", profile?.userId),
        orderBy("date", "desc"),
        //limit(3)
      );
      const unsub = onSnapshot(qu, (snap) => {
        const arr = [];

        snap.forEach((doc) => {
          arr.push({ ...doc.data() });
        });
        setEntitesMessage([...arr]);
      });
      return () => {
        unsub();
      };
    };
    profile && getData();
  }, []);

  const [profileImages, setProfileImages] = useState(new Map());

useEffect(() => {
  const fetchImages = async () => {
    const newMap = new Map();

    for (const item of entitiesMessage) {
      const id = item?.senderProfilePicture;
      if (id && id !== "string") {
        const result = await dispatch(GetProfileImages(id));
        const imageUrl = result?.payload?.isActive;
        if (imageUrl != null) {
          newMap.set(item.senderId, imageUrl);
        }else{
            newMap.set(item.senderId, DEFAULT_AVATAR_URL);
        }
      }
    }

    setProfileImages(newMap);
  };

  fetchImages();
}, [entitiesMessage, dispatch]);

  return (
    <>
      <List sx={{ width: "100%", bgcolor: "background.paper" ,maxHeight: "292px" , overflowY: 'auto' }}>
        {entitiesMessage.length > 0 &&
          entitiesMessage?.map((message, index) => (
            <React.Fragment key={index}>
              <ListItemButton
                sx={{ pl: 1, pr: 0 }}
                selected={selectedIndex === index}
                onClick={(event) =>
                  handleListItemClick(event, index, message, message?.chatUid)
                }
              >
                <ListItem alignItems="flex-start" sx={{ pl: 0, pr: 0 }}>
                  <ListItemAvatar>
                    <Avatar
                      alt={message.senderName}
                      sx={{
                        backgroundColor: "green",
                        "& img": {
                          height:
                            message?.senderProfilePicture === "string" ||
                            message?.senderProfilePicture === null
                              ? "100%"
                              : "100%",
                          width:
                            message?.senderProfilePicture === "string" ||
                            message?.senderProfilePicture === null
                              ? "100%"
                              : "100%",
                        },
                      }}
                      src={
                        message?.senderProfilePicture === "string" ||
                        message?.senderProfilePicture === null
                          ? DEFAULT_AVATAR_URL
                          : profileImages.get(message?.senderId)
                      }
                    />
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography sx={{ wordBreak: "break-all" }}>
                        {message?.senderName}
                      </Typography>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary"
                        >
                          {message.text}
                        </Typography>{" "}
                        {`${new Date(
                          message.collectionCreatedDate
                        ).getFullYear()}${message.collectionId}`}
                      </React.Fragment>
                    }
                  />
                  <Chip
                    label={message.isRead ? t("read") : t("unRead")}
                    icon={
                      message.isRead ? (
                        <CheckIcon
                          sx={{ color: "#1B727E", fontSize: "small" }}
                        />
                      ) : (
                        <FiberManualRecordIcon
                          sx={{ color: "pink", fontSize: "small" }}
                        />
                      )
                    }
                    sx={{
                      backgroundColor: message.isRead ? "#E4F2E8" : "#ffcbcb82",
                      // color: message.isRead ? "#1B727E" : "red",
                      width: "fit-content",
                      justifyContent:"left",
                      mx: 1,
                      "& .MuiChip-label": {
                        fontWeight: 600,
                        fontFamily: "Poppins",
                      },
                      "& .MuiChip-icon": {
                        color: message.isRead ? "#1B727E" : "red",
                      },
                    }}
                  />
                </ListItem>
              </ListItemButton>
              <Divider variant="outset" component="li" />
            </React.Fragment>
          ))}
        {entitiesMessage.length === 0 && (
          <Typography
            sx={{ display: "inline" }}
            variant="body2"
            color="text.primary"
            textAlign="center"
          >
            {t("noChat")}
          </Typography>
        )}
      </List>
      <ChatPanel
        chatUid={chatId}
        particularChatDonation={particularDonation}
        entityDonation={entityDonation}
        chatdrawerState={chatdrawerState}
        toggleChatDrawer={toggleChatDrawer}
        t={t}
      />
    </>
  );
}
